// Update the app/eworkflows/users/permissions/get.ts file when this file is updated
import { IPermission } from '../../../../../app/entities/Permission'
import { IUser } from '../../../../../app/entities/User'

function getUserPermissions(user: IUser | null): IPermission[] {
  return user?.role?.permissions || []
}

export default getUserPermissions
